R = require 'ramda'
impl = require './resources2'

getURL = R.prop('url')

loadResource = R.compose impl.loadResourceFromURL, getURL
loadResourceUrl = impl.loadResourceFromURL
createResource = impl.createResource
updateResource = impl.updateResource
findResourceLink = impl.findResourceLink

module.exports =
  loadResource: loadResource
  loadResourceFromUrl: loadResourceUrl
  createResource: createResource
  updateResource: updateResource
  findResourceLink: findResourceLink
